import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";
import { sanitizeFileName } from "@sf-core";
import { ExportFileNames } from "../constants/exportFileNames";

export const getUserTenantRole = async (userId, tenantId) => {
  return base.get({
    url: API_PARAM.TENANT_USER_ROLE,
    params: { id: userId, tenantId },
  });
};

export const getUserTenants = async (userId) => {
  return base.get({
    url: API_PARAM.USER_TENANTS,
    params: { id: userId },
  });
};

export const getTenantRoles = async (tenantId) => {
  return base.get({
    url: API_PARAM.TENANT_ROLES,
    params: { tenantId },
  });
};

export const getAllTenants = async () => {
  return base.get({
    url: `${API_PARAM.TENANTS}`,
  });
};

export const addTenantToUser = async (data) => {
  return base.post({
    url: API_PARAM.TENANT_USER,
    data,
    params: { tenantId: data.tenantId },
    nonceHeader: true,
  });
};

export const editTenantUser = async (data) => {
  return base.patch({
    url: API_PARAM.TENANT_USER,
    data,
    params: { tenantId: data.tenantId },
  });
};

export const deleteTenantUser = async (data) => {
  return base.deleteRequest({
    url: API_PARAM.TENANT_USER,
    data,
    params: { tenantId: data.tenantId },
  });
};

export const restoreTenantUser = async (data) => {
  return base.patch({
    url: API_PARAM.TENANT_USER_RESTORE,
    data,
    params: { tenantId: data.tenantId },
  });
};

export const getTenantUserSubscriptionConfig = async (tenantId) => {
  return base.get({
    url: API_PARAM.TENANT_USER_SUBSCRIPTION,
    params: { tenantId },
  });
};

export const exportTenantsGrid = async (filterModel) => {
  return base.exportFile({
    url: API_PARAM.TENANTS_EXPORT,
    data: filterModel,
    fileName: sanitizeFileName(ExportFileNames.TENANTS),    
  });
};
